import { quickpayConstants } from "./e_quick-pay-constants";

const quickpay = (res) => async (dispatch) => {
    dispatch({
      type: quickpayConstants.QUICK_PAY_SUCCESS,
      accountInfo: res.data,
      loading: false,
    }) 
};


export { quickpay };
